import React from 'react';
import { Select } from 'antd';
import CountryName from "../../../assets/country.json";

const CountrySelect = ({ country, setCountry }) => {
    const getCountryData = () => {
        const menuList = Object.keys(CountryName)
            .filter((filterKey) => !['KR', 'US', 'JP', 'TW', 'CN', 'HK', 'TH'].includes(filterKey))
            .map((key) => (
                {label: CountryName[key].name_kr, code: key}
            ));
        const postList = [
            {label: '전체', code: 'ALL'},
            {label: '일본', code: 'JP'},
            {label: '한국', code: 'KR'},
            {label: '미국', code: 'US'},
            {label: '태국', code: 'TH'},
            {label: '대만', code: 'TW'},
            {label: '중국', code: 'CN'},
            {label: '홍콩', code: 'HK'}
        ];
        return [...postList, ...menuList];
    }

    const options = getCountryData();

    return (
        <div style={{ marginRight: '10px' }}>
            <Select
                showSearch
                value={country}
                style={{ width: 200 }}
                optionFilterProp="label"
                onChange={setCountry}
                filterOption={(input, option) =>
                    option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                popupMatchSelectWidth={false}
            >
                {options.map(option => (
                    <Select.Option key={option.code} value={option.code} label={option.label}>
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                            <img
                                src={`https://flagcdn.com/20x15/${option.code.toLowerCase()}.png`}
                                srcSet={`https://flagcdn.com/40x30/${option.code.toLowerCase()}.png 2x`}
                                alt=""
                                style={{ marginRight: 8 }}
                            />
                            {option.label}
                        </span>
                    </Select.Option>
                ))}
            </Select>
        </div>
    );
}

export default CountrySelect;